import { useMelwaysLink } from '@seek/melways-react';
import { useTranslations } from '@vocab/react';
import { TextLink } from 'braid-design-system';
import { useCallback } from 'react';

import { useAnalyticsFacade } from 'src/modules/AnalyticsFacade';

import { MessageWrapper } from '../SharedComponent/MessageWrapper/MessageWrapper';

import translations from './.vocab';

export const CareerFeedEmptyState = () => {
  const profileLink = useMelwaysLink({
    path: '/profile/me',
  });
  const analyticsFacade = useAnalyticsFacade();

  const profileLinkOnClick = useCallback(() => {
    analyticsFacade.linkClicked({
      href: profileLink,
      linkName: 'dashboard-recommended-jobs-profile',
    });
  }, [analyticsFacade, profileLink]);

  const { t } = useTranslations(translations);

  return (
    <MessageWrapper>
      {t('Update your profile or start searching', {
        Link: (children) => (
          <TextLink
            weight="weak"
            target="_blank"
            href={profileLink}
            onClick={profileLinkOnClick}
          >
            {children}
          </TextLink>
        ),
      })}
    </MessageWrapper>
  );
};
